import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cef3a96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-order-wrapper" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "new-order-title-wrapper" }
const _hoisted_4 = { class: "new-order-title" }

import { ref } from 'vue'
import { useRouter } from 'vue-router'

import ArrowBackSvg from '@/components/ArrowBackSvg.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import EmptyingOrder from '@/components/NewOrder/EmptyingOrder.vue'
import FreeSwitchingOrder from '@/components/NewOrder/FreeSwitchingOrder.vue'
import GatheringOrder from '@/components/NewOrder/GatheringOrder.vue'
import OverheadLoadingOrder from '@/components/NewOrder/OverheadLoadingOrder.vue'
import PickupOrder from '@/components/NewOrder/PickupOrder.vue'
import PickupAndWeighOrder from '@/components/NewOrder/PickupAndWeighOrder.vue'
import PositioningOrder from '@/components/NewOrder/PositioningOrder.vue'
import SwitchingOrder from '@/components/NewOrder/SwitchingOrder.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const currentOrderType = router.currentRoute.value.query.type

const loading = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "icon-button",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createVNode(ArrowBackSvg)
              ]),
              _: 1
            }),
            _createElementVNode("h1", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t('newOrder.createNewOrder')) + ": ", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`availableOrderTypes.${_unref(currentOrderType)}`)), 1)
            ])
          ]),
          (_unref(currentOrderType) == 'EmptyingOrder')
            ? (_openBlock(), _createBlock(EmptyingOrder, { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(currentOrderType) == 'FreeSwitchingOrder')
            ? (_openBlock(), _createBlock(FreeSwitchingOrder, { key: 1 }))
            : _createCommentVNode("", true),
          (_unref(currentOrderType) == 'GatheringOrder')
            ? (_openBlock(), _createBlock(GatheringOrder, { key: 2 }))
            : _createCommentVNode("", true),
          (_unref(currentOrderType) == 'OverheadLoadingOrder')
            ? (_openBlock(), _createBlock(OverheadLoadingOrder, { key: 3 }))
            : _createCommentVNode("", true),
          (_unref(currentOrderType) == 'PickupOrder')
            ? (_openBlock(), _createBlock(PickupOrder, { key: 4 }))
            : _createCommentVNode("", true),
          (_unref(currentOrderType) == 'PickupAndWeighOrder')
            ? (_openBlock(), _createBlock(PickupAndWeighOrder, { key: 5 }))
            : _createCommentVNode("", true),
          (_unref(currentOrderType) == 'PositioningOrder')
            ? (_openBlock(), _createBlock(PositioningOrder, { key: 6 }))
            : _createCommentVNode("", true),
          (_unref(currentOrderType) == 'SwitchingOrder')
            ? (_openBlock(), _createBlock(SwitchingOrder, { key: 7 }))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})